import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { BillingTermType } from '../../../../shared/model-typings';

import { getBillingTermsQueryKey } from './useBillingTerms';

type AddBillingTermParams = {
  termStart: Date;
  termEnd: Date;
  quantity: number;
  type: BillingTermType;
};

async function addBillingTerm(params: AddBillingTermParams): Promise<void> {
  await post('/api/organization/billing-terms', params);
}

/**
 * Hook to add a new billing term for the current organization.
 * @returns Mutation function to add a billing term
 */
export const useAddBillingTerm = () => {
  return useToastedMutation({
    mutationFn: addBillingTerm,
    successToastMessage: 'Billing term added successfully',
    errorToastMessage: 'Failed to add billing term',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBillingTermsQueryKey() });
    },
  });
};
